import { formatMinorUnits } from "@laundrypro/shared";
import type { UiLanguage } from "@laundrypro/shared";

/**
 * Presentation formatting shared by the operational screens.
 *
 * Money renders through the shared minor-unit formatter — Latin digits, two
 * decimals, no separators — with the currency word supplied SEPARATELY by the
 * caller as its own span, so the number stays one unbroken LTR run inside an
 * RTL sentence.
 */

export function money(minor: number): string {
  return formatMinorUnits(minor);
}

export function currencyLabel(language: UiLanguage, code = "SAR"): string {
  return language === "ar" ? "ر.س" : code;
}

/** Locale-formatted date + time for table cells. */
export function dateTime(iso: string | null, language: UiLanguage): string {
  if (!iso) return "—";
  const locale = language === "ar" ? "ar-SA" : "en-US";
  try {
    return new Date(iso).toLocaleString(locale, {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

/** Date only, for expected-ready columns where the time is noise. */
export function dateOnly(iso: string | null, language: UiLanguage): string {
  if (!iso) return "—";
  const locale = language === "ar" ? "ar-SA" : "en-US";
  try {
    return new Date(iso).toLocaleDateString(locale, { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}
